import React from 'react';
import {
  TestimonialDesignation,
  TestimonialPara,
  TestimonialText,
  TestimonialUser,
} from './Testimonial.styled';

/**
 * TestimonialCard component displays an individual testimonial card within a slider.
 *
 * @component
 * @param {Object} props - The properties for the TestimonialCard component.
 * @returns {JSX.Element} The rendered TestimonialCard component.
 */

const TestimonialCard = (props) => {
  return (
    <div className='item' key={props.id}>
      <TestimonialText>
        <TestimonialPara>{props.text}</TestimonialPara>
      </TestimonialText>
      <TestimonialUser>
        <img src={props.img} alt='Testimonial User Image' loading='lazy' />
        <TestimonialDesignation>
          <b>{props.name}</b>
          <span>{props.designation}</span>
        </TestimonialDesignation>
      </TestimonialUser>
    </div>
  );
};

export default TestimonialCard;
